import './assets/style.css';
import './assets/bootstrap.min.css';
import './assets/fontawesome.min.css';
import {
  Switch,
  Route
} from "react-router-dom";
import Main from './container/Main';
import React from 'react';
// import ReactGA from 'react-ga';

function App() {
  // React.useEffect(() => {
  //   ReactGA.initialize('UA-136659498-1');
  //   ReactGA.pageview(window.location.pathname + window.location.search);
  // },[])

  return (
    <Switch>
      <Route path="/" exact>
        <Main />
      </Route>
    </Switch>
  );
}

export default App;
